const LiveIcon = () => {
  return (
    <svg width={40} height={40} fill='currentColor' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'>
      <path d='M35.65,26.43V13.53A2.49,2.49,0,0,0,33.2,11H7a2.64,2.64,0,0,0-2.6,2.6v12.9A2.58,2.58,0,0,0,7,29h26.2a2.5,2.5,0,0,0,2.5-2.5Zm-16.19-4a2.5,2.5,0,0,1,0-4.88Zm1.08-4.88a2.5,2.5,0,0,1,0,4.88ZM5.4,17.38H8a.21.21,0,0,1,.2.2v4.7a.22.22,0,0,1-.2.2H5.4Zm0,9.1h0v-2.8H8a1.33,1.33,0,0,0,1.3-1.3V17.63A1.32,1.32,0,0,0,8,16.33H5.4v-2.8A1.44,1.44,0,0,1,6.8,12h0l12.66,0v4.5a3.49,3.49,0,0,0,0,6.9v4.48L7,28A1.61,1.61,0,0,1,5.45,26.48Zm29.15-3.9H32.1a.22.22,0,0,1-.2-.2V17.63a.21.21,0,0,1,.2-.2l2.5.05Zm0-6.2H32.1a1.32,1.32,0,0,0-1.3,1.3v4.7a1.33,1.33,0,0,0,1.3,1.3h2.5v2.8a1.52,1.52,0,0,1-1.5,1.4l-12.56,0V23.45a3.49,3.49,0,0,0,0-6.9v-4.5l12.56,0a1.54,1.54,0,0,1,1.5,1.5Z'></path>
    </svg>
  );
};

export default LiveIcon;
